<template>
  <div
    class="mb-4 rounded-lg border border-gray-200 bg-white px-5 py-5 hover:shadow-sm lg:mb-0 lg:px-5 lg:py-10"
  >
    <div
      class="card-icon mb-5 flex h-9 w-9 items-center justify-center rounded-md border border-green-200 bg-green-50 text-[#05796B]"
    >
      <CheckCircleIcon />
    </div>
    <span
      class="block text-base font-medium leading-tight text-gray-900 lg:text-base lg:leading-tight"
    >{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'BenefitCard',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
}
</script>
